import { inject, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationMethod } from '@models';
import { Store } from '@ngrx/store';
import { AppState } from '@store';
import { AuthenticationService } from './authentication.service';
import { UtilitiesService } from './utilities.service';

@Service()
export class SamlService {
  auth = inject(AuthenticationService);
  store = inject<Store<AppState>>(Store);
  utilitiesService = inject(UtilitiesService);

  samlBaseURL: string | undefined;

  constructor() {
    this.store
      .select((state) => state)
      .pipe(takeUntilDestroyed())
      .subscribe((state) => {
        this.samlBaseURL = state.settings?.system?.SAML_BASE_URL;
      });
  }

  getSamlBaseURL = async () => {
    if (this.samlBaseURL) {
      return true;
    }

    const settings = await this.auth.getSystemSettings();

    return settings?.SAML_BASE_URL ?? 'noSamlURL';
  };

  getEIamPortalUrl = () =>
    this.utilitiesService.getEIamPortalUrl().catch(() => {});

  isFinmaUser = (authenticationMethods: { type: number }[] | undefined) =>
    authenticationMethods !== undefined &&
    authenticationMethods[0]?.type === AuthenticationMethod.FINMA_SSO;
}
